/**
 * 数据字典路由配置
 */
const dictRoute = {
  path: 'dict',
  name: 'dict',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'dictList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '数据字典',
        isCache: true,
        /** 与 query.dictType 合并为同一 navTab，避免从业务弹窗跳转时重复开页签 */
        ignoreDiff: ['dictType'],
        isIframe: false
      }
    }
  ]
};

export default dictRoute;
